import { Flex, Text, Checkbox, Card, Box } from '@scale/scaleui-radix';
import { UserTable } from 'react-scale/corp/views/CorpProjectGroupManager/apps/Webinars/components/UserTable';
import { isNil } from 'lodash';
import ClaimHostsCallout from 'react-scale/components/WebinarSessions/components/ClaimHostsCallout';

interface WebinarInviteesSummaryProps {
  invitedUsers: string[];
  setInvitedUsers: (invitedUsers: string[]) => void;
  sendInvitationEmails?: boolean;
  setSendInvitationEmails?: (sendInvitationEmails: boolean) => void;
  send30MinuteReminderEmails?: boolean;
  setSend30MinuteReminderEmails?: (send30MinuteReminderEmails: boolean) => void;
  allInvitedUserIds: string[];
}

const WebinarInviteesSummary = ({
  invitedUsers,
  setInvitedUsers,
  sendInvitationEmails,
  setSendInvitationEmails,
  send30MinuteReminderEmails,
  setSend30MinuteReminderEmails,
  allInvitedUserIds,
}: WebinarInviteesSummaryProps) => {
  const showInvitationAndReminderFields =
    !isNil(sendInvitationEmails) &&
    !isNil(send30MinuteReminderEmails) &&
    !isNil(setSendInvitationEmails) &&
    !isNil(setSend30MinuteReminderEmails);

  return (
    <Flex direction="column" gap="4">
      {allInvitedUserIds.length > 0 && (
        <Card className="w-full min-h-fit max-h-[70vh] overflow-y-auto">
          <Box p="4">
            <UserTable
              userIds={allInvitedUserIds}
              invitedUserIds={invitedUsers}
              setInvitedUserIds={setInvitedUsers}
              label="Selected Invitees"
            />
          </Box>
        </Card>
      )}
      {showInvitationAndReminderFields && (
        <Card className="w-full min-h-fit max-h-[70vh] overflow-y-auto">
          <Box p="4">
            <Flex direction="column" gap="2">
              <Text as="label" size="2" weight="medium">
                Email Invitations
              </Text>
              <Text as="label" size="2">
                <Flex as="span" gap="2">
                  <Checkbox
                    size="2"
                    checked={sendInvitationEmails}
                    onCheckedChange={setSendInvitationEmails}
                  />
                  Send email invitations upon webinar creation
                </Flex>
              </Text>
              <Text as="label" size="2">
                <Flex as="span" gap="2">
                  <Checkbox
                    size="2"
                    checked={send30MinuteReminderEmails}
                    onCheckedChange={setSend30MinuteReminderEmails}
                  />
                  Send reminder emails for RSVPs 30 minutes before
                </Flex>
              </Text>
            </Flex>
          </Box>
        </Card>
      )}
      <ClaimHostsCallout />
    </Flex>
  );
};

export default WebinarInviteesSummary;
